import { lazy } from 'react';

export const lazyload = (promise: Promise<any>, namedExport: string) => {
  return lazy(() =>
    promise.then((module) => {
      return { default: module[namedExport] };
    }),
  );
};
